import { NotificationItem } from './notifications.repository';

export const mockNotificationData: NotificationItem[] = [
  {
    dateCreated: '20231113T212714.117 GMT',
    id: '4fcde190-2ffe-4b09-9279-f7abdffbc0e7',
    isRead: true,
    textMessage:
      'Republic Services: Due to severe weather circumstances, your solid waste service at 8102 FOUR WINDS DR will be delayed by one day. We apologize for the inconvenience and will provide your service as soon as safely possible. Stay safe and we will see you soon! ',
  },
  {
    dateCreated: '20231107T235314.865 GMT',
    id: '90298b4b-75cc-472a-868f-3791ad297547',
    isRead: true,
    textMessage:
      'Republic Services: Your normal dumpster service is coming up! We will be at 8102 FOUR WINDS DR to pick up your solid waste on November 08, 2023. Please make sure the area around the dumpster is clear and it is accessible by the truck. Click the link to track your service https://rsi.page.link/j2uW . ',
  },
  {
    dateCreated: '20231107T162548.096 GMT',
    id: 'ee3d0634-8122-4099-9d39-6f9ef3617484',
    isRead: true,
    textMessage:
      'Republic Services: Your normal dumpster service is coming up! We will be at 8102 FOUR WINDS DR to pick up your solid waste on November 08, 2023. Please make sure the area around the dumpster is clear and it is accessible by the truck. Click the link to track your service https://rsi.page.link/vX5J . ',
  },
  {
    dateCreated: '20231106T160409.804 GMT',
    id: 'b3998c38-d6b3-4493-b836-6447b7802f4b',
    isRead: true,
    textMessage:
      "Republic Services: We're sorry we missed your recent service date. We will pick up your solid waste at 8102 FOUR WINDS DR on November 15, 2023. ",
  },
  {
    dateCreated: '20231106T160409.748 GMT',
    id: '1512d023-8c5a-415d-9d6f-a921a9cb2dc9',
    isRead: true,
    textMessage:
      'Republic Services: Your service is scheduled. We will be at 8102 FOUR WINDS DR to service your solid waste on November 15, 2023. Please make sure the area around the container is clear and it is accessible by the truck.',
  },
  {
    dateCreated: '20231106T160409.740 GMT',
    id: '44b5a854-75bd-494a-954b-135546bea657',
    isRead: true,
    textMessage:
      'Republic Services: Your service is scheduled. We will be at 8102 FOUR WINDS DR to service your solid waste on November 15, 2023. Please make sure the area around the container is clear and it is accessible by the truck.',
  },
];
